import { combineReducers } from 'redux';
import App from '@iso/redux/app/reducer';
import Auth from '@iso/redux/auth/reducer';
import ThemeSwitcher from '@iso/redux/themeSwitcher/reducer';
import LanguageSwitcher from '@iso/redux/languageSwitcher/reducer';
import Cat from '@iso/redux/category/reducer';
import CatTree from '@iso/redux/categorytree/reducer';
import GrpSwitch from '@iso/redux/groupSwitch/reducer';
import Groups from '@iso/redux/groups/reducer';
import Labels from '@iso/redux/labels/reducer';
import Categories from '@iso/redux/categories/reducer';
import Products from '@iso/redux/product/reducer';
import LogProducts from '@iso/redux/logProduct/reducer';
import Country from '@iso/redux/country/reducer';
import DataSource from '@iso/redux/dataSource/reducer';
import User from '@iso/redux/user/reducer';
import Master from '@iso/redux/master/reducer';
import BrandManufacturer from '@iso/redux/brandManufacturer/reducer';
import Logs from "@iso/redux/logs/reducer";

export default combineReducers({
  Auth,
  App,
  ThemeSwitcher,
  LanguageSwitcher,
  Cat,
  CatTree,
  GrpSwitch,
  Groups,
  Labels,
  Categories,
  Products,
  LogProducts,
  Country,
  User,
  Master,
  DataSource,
  BrandManufacturer,
  Logs
});
